// extracted by mini-css-extract-plugin
export var header = "_gj-0";